import * as authStorage from '@/services/api/utils/authStorage';
import { ensureFreshAccessToken } from '@/services/api/utils/tokenAuth';

/**
 * Resolves to null for a guest; a rejected refresh token logs the user out first, so the plugin
 * sees a guest afterwards. Rejects when the refresh failed for a temporary reason.
 */
export const getAuthToken = async (): Promise<string | null> => {
  if (!authStorage.getAccessToken()) {
    return null;
  }
  await ensureFreshAccessToken();
  return authStorage.getAccessToken();
};
